"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _vuex = _interopRequireDefault(require("vuex"));
var _app = _interopRequireDefault(require("./modules/app"));
var _common = _interopRequireDefault(require("./modules/common"));
var _user = _interopRequireDefault(require("./modules/user"));
var _tagsView = _interopRequireDefault(require("./modules/tagsView"));
var _permission = _interopRequireDefault(require("./modules/permission"));
var _settings = _interopRequireDefault(require("./modules/settings"));
var _dataConfig = _interopRequireDefault(require("./modules/dataConfig"));
var _activityManage = _interopRequireDefault(require("./modules/activityManage"));
var _getters = _interopRequireDefault(require("./getters"));
_vue.default.use(_vuex.default);
var store = new _vuex.default.Store({
  modules: {
    app: _app.default,
    user: _user.default,
    tagsView: _tagsView.default,
    permission: _permission.default,
    settings: _settings.default,
    dataConfig: _dataConfig.default,
    common: _common.default,
    activityManage: _activityManage.default
  },
  getters: _getters.default
});
var _default = exports.default = store;